import { MtProjectPermissions } from "server/models"
import {
    GET,
    POST,
    ProjectPermissions,
    ProjectPermissionsSectioned,

    createProjectPermissions,
    copyProjectPermission,
} from "client/store/utils"
import {
    LangType,
    LoadAccountPermissions,
} from "client/store"


export const LoadProjectPermissions = (
    accountId: number,
    projectId: number,
    lang?: LangType,
) => (
    LoadAccountPermissions(accountId)
    .then((res1) => (
        GET(`/mtProjectPermissions/projectId/${projectId}`)
        .then((res2: MtProjectPermissions) => {
            const baseProjectPermissions = res1.projectPermissions
            const projectPermissions = res2 && res2.permissions ? JSON.parse(res2.permissions) : {}

            const initPermissions = createProjectPermissions(lang || null)
            const permissions = <ProjectPermissions>initPermissions.permissions
            const permissionsSectioned = <ProjectPermissionsSectioned>initPermissions.permissionsSectioned

            Object.keys(permissionsSectioned).forEach((section) => {
                Object.keys(permissionsSectioned[section]).forEach((permissionId: string) => {
                    let resPermission = permissions[permissionId]
                    resPermission = copyProjectPermission(resPermission, baseProjectPermissions[permissionId], false, true)
                    resPermission = copyProjectPermission(resPermission, projectPermissions[permissionId], true, false)

                    permissions[permissionId] = copyProjectPermission(permissions[permissionId], resPermission, true, true)
                    permissionsSectioned[section][permissionId] = copyProjectPermission(
                        permissionsSectioned[section][permissionId],
                        resPermission,
                        true,
                        true,
                    )
                })
            })

            return { permissions, permissionsSectioned }
        })
    ))
)

export const SaveProjectPermissions = (
    projectId: number,
    permissionsSectioned: ProjectPermissionsSectioned,
) => {
    const permissions: ProjectPermissions = {}

    Object.keys(permissionsSectioned).forEach((section) => {
        Object.keys(permissionsSectioned[section]).forEach((permissionId) => {
            permissions[permissionId] = permissionsSectioned[section][permissionId]
        })
    })

    const data: MtProjectPermissions = {
        projectId,
        permissions: JSON.stringify(permissions),
    }

    return POST(
        "/mtProjectPermissions/save",
        JSON.stringify(data),
    )
}
